
































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import LoyaltyExample from '@/components/molecules/LoyaltyExample/LoyaltyExample.vue';
import PercentageCircleIcon from '@/components/icons/PercentageCircle.vue';
import InfoIcon from '@/components/icons/Info.vue';
import { Radio } from '@/components/molecules';
import flagKeys from '@/constants/flagKeys';
import { EBusinessRewardsStatus } from '@/models/business';

@Component({
  components: {
    Typography,
    Surface,
    LoyaltyExample,
    TextField,
    PercentageCircleIcon,
    Radio,
    InfoIcon
  }
})
export default class BonusSectionSetting extends Vue {
  @Prop({ default: '5%' }) readonly value!: string;
  @Prop() readonly error!: any[];
  @Prop({ default: false }) readonly hasError?: boolean;

  percentageOther: string = '';
  coinRewardPercentage: string = this.$store.getters[
    'business/getBusinessState'
  ].coinRewardPercentage;
  radioValue: string = this.getRewardValues()[0];
  bonusThresholdLimit: number = 30;
  values: Array<string> = this.getRewardValues();

  get customerImage() {
    return '/img/onboarding/customer-example.png';
  }

  mounted() {
    this.getRewardValues();
    if (this.isMobileDevice) return;
  }

  getRewardValues() {
    let coinRewardPercentage = 5;
    const flags = this.$store.getters['flags/getFlags'] || [];

    if (this.isFeatureFlagAndLoyaltActive) {
      coinRewardPercentage = this.$store.getters['business/getBusinessState']
        .coinRewardPercentage;
      coinRewardPercentage =
        coinRewardPercentage < 5 ? 5 : coinRewardPercentage;
    }

    const roundedValue = Math.ceil(coinRewardPercentage / 5) * 5;
    this.values = [
      roundedValue + '%',
      roundedValue + 5 + '%',
      roundedValue + 10 + '%'
    ];
    return this.values;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'sellCoins.campaign.bonusSection';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business) return '';

    return business.logo.publicPath.large;
  }

  get isFeatureFlagAndLoyaltActive() {
    const flags = this.$store.getters['flags/getFlags'] || [];
    const getRewardStatus = this.$store.getters['business/getRewardStatus'];

    const rewardOk =
      getRewardStatus &&
      getRewardStatus.rewardStatus !== EBusinessRewardsStatus.INACTIVE;

    const featureFlag = flags.includes(
      flagKeys.dashboardSellCoinsAndLoyaltVerify
    );
    return featureFlag && rewardOk;
  }

  isValidNumber(event: any) {
    const strReg =
      this.percentageOther.length === 0 ? '^[1-9][0-9]*$' : '^[0-9]*$';

    let regexp = new RegExp(strReg);

    if (!regexp.test(event.key)) {
      return event.preventDefault();
    }
  }

  get percentInCoins() {
    let strBonus = this.radioValue;

    if (strBonus === 'Other') {
      strBonus = this.percentageOther;
    }

    let auxBonus = parseInt(strBonus.replace('%', ''));

    return Math.round(100 * (1 + auxBonus / 100));
  }

  private onChangeOther(event: any) {
    const inputOther = this.$refs.inputOther as HTMLInputElement;
    let inputValue = event.target.value + '%';

    inputOther.style.width = inputValue.length <= 2 ? '14px' : '26px';
    this.$emit('input', inputValue);
  }

  private onChange(value: any) {
    this.$emit('input', value);
    this.radioValue = value;
    this.percentageOther = '';

    if (value === 'Other') {
      if (this.isFeatureFlagAndLoyaltActive && !this.percentageOther) {
        this.percentageOther = this.getRewardValues()[0].replace('%', '');
      }
      setTimeout(() => {
        const input = this.$refs.inputOther as HTMLInputElement;
        if (this.isFeatureFlagAndLoyaltActive) {
          input.style.width =
            this.percentageOther.length <= 1 ? '14px' : '26px';
        }
        input.focus();
      }, 200);
    }
  }
}
